export function formatDate (strTime) {
  let date = new Date(strTime)
  return date.getFullYear() + '-' + (date.getMonth() + 1).toString() + '-' + date.getDate()
}

export function deBouce (callBack, duration) {
  let t = null
  if (t) {
    window.clearTimeout(t)
  }
  t = setTimeout(() => {
    if (callBack) callBack()
  }, duration)
}

const nanoid = require('nanoid')
export function getUUID () {
  return nanoid()
}



// WEBPACK FOOTER //
// ./src/utils/index.js